import DatePickerCalendar from 'components/form/DatePickerCalendar/styled';

export default DatePickerCalendar;
